import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataSharingService } from '../common/services/data-sharing.service';
import { ConfigurationService } from '../crm/services/configuration.service';
import { ToastsManager } from 'ng2-toastr';
import { UserDc } from "../common/models/login/user-dc";
import { SessionHelper } from '../common/helpers/session.helper';
import { AuthService } from '../common/services/auth.service';
import { PermissionService } from '../security/permission.service';


@Component({
  selector: 'app-join-via-creditupclub',
  templateUrl: './join-via-creditupclub.component.html',
  styleUrls: ['./join-via-creditupclub.component.scss']
})

export class JoinViaCreditUpClub implements OnInit {
  state: string = '';
  error: any;
  accountNumber: string;
  companyKey: string;
  softKey: string;
  email: string;
  companyName: string = "";
  companyLogoUrl: string = "";
  firstName: string = "";
  lastName: string = "";
  middleName: string = "";
  valid: boolean = true;

  constructor(private activatedRoute: ActivatedRoute, private router: Router, 
    private dataSharingService: DataSharingService, private configurationService: ConfigurationService,
    private toastr: ToastsManager, vcr: ViewContainerRef,
    private permissionService: PermissionService,
    private authService: AuthService) {
      this.toastr.setRootViewContainerRef(vcr);
  }

  async ngOnInit() {
    try {
      this.dataSharingService.setShowLoader(true);
      const queryParams: any = this.activatedRoute.snapshot.queryParams;
      // const queryParams = {
      //   first_name: 'johnschwab',
      //   last_name: 'referral 19 dec',
      //   email: 'johnschwabreferral1912@tcrmen.com',
      //   goal: 'Buy+a+home',
      //   phone: "(334)+343-4312",
      //   form_url: 'https://creditupclub.com?ref=johnschwab3',
      //   comments: null,
      //   score_range: 0
      // }

      // console.log('queryParams', (queryParams.first_name.replace('+', ' ')));
      if (queryParams) {
        if (queryParams.first_name && queryParams.last_name && queryParams.email && queryParams.goal) {
          const data: any = {
            FirstName: queryParams.first_name.replace('+', ' '),
            LastName: queryParams.last_name.replace('+', ' '),
            EmailAddress: queryParams.email,
            PrimaryPhone: queryParams.phone ? queryParams.phone : '',
            Goal: queryParams.goal ? queryParams.goal.replace('+', ' ') : '',
            FormUrl: queryParams.form_url && queryParams.form_url.trim() != '' ? encodeURI(queryParams.form_url) : null,
            Comments: queryParams.comments ? queryParams.comments.replace('+', ' ') : '',
            ScoreRange: queryParams.score_range ? queryParams.score_range : 0,
            CustomerSystemIP: queryParams.client_ip ? queryParams.client_ip : null,
            Address:  queryParams.address ? queryParams.address.replace('+', ' ') : null,
            City:  queryParams.city ? queryParams.city.replace('+', ' ') : null,
            StateId:  queryParams.StateId ? queryParams.StateId.replace('+', ' ') : null,
            Zipcode:  queryParams.zip ? queryParams.zip : null,
          }
          let currentDomain = window.location.hostname;
          if (currentDomain == "myhomeroadmap.com" || currentDomain == "www.myhomeroadmap.com") {
            data['ProgramId'] = 5;  // ProgramId for  HomeRoadMap           
          }
          this.onSubmit(data);
        } else {
          this.dataSharingService.setShowLoader(false);
          this.toastr.error('Some fields are missing, please go back and try again');
          this.router.navigateByUrl('/auth/login');
        }
      } else {
        this.dataSharingService.setShowLoader(false);
        this.toastr.error('Something went wrong, please go back and try again');
        window.history.back();
      }
    }
    catch (ex) {
      this.dataSharingService.setShowLoader(false);
      this.toastr.error('Something went wrong, please go back and try again');
      window.history.back();
    }
  }

  onSubmit(formData) {
    try {
      this.configurationService.joinCreditUpClub(formData).subscribe((res: any) => {
        this.dataSharingService.setShowLoader(false);
        if (res && res.Message == 'Success') {
          let userDc: UserDc = res ? res : new UserDc();
          userDc.Message = "Do not have permission";
          if (
            userDc.AuthenticationId > 0 &&
            userDc.Result == true &&
            userDc.CustomerPortal != 2
          ) {
            SessionHelper.setUser(userDc);
            this.authService.setToken(userDc.Token);
            this.router.navigate(['/home/customer']);
            // this.permissionService.setPermission(userDc.UserType).then((res) => {
            //   this.permissionService.navigationBasedOnUserType(userDc.UserType);
            //   this.dataSharingService.setShowLoader(false);
            // });
          } else {
            this.error = userDc.Message;
          }
        } else {
          this.toastr.error('Something went wrong, please go back and try again');
        }
      }, error => {
        this.dataSharingService.setShowLoader(false);
        // console.log(error);
        this.toastr.error('Something went wrong, please go back and try again');
      });
    } catch (error) {
      this.dataSharingService.setShowLoader(false);
      // console.log(error);
    }
  }
}



// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/join-via-creditupclub/join-via-creditupclub.component.ts